import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
import React, {
    useCallback, useState, useMemo, useContext, useEffect
} from 'react';
import messages from './PaymentPreference.messages';
import styles from './PaymentPreference.module.scss';
import { ModalNextProvider } from "@jutro/components";
import metadata from './PaymentPreference.meatadata.json5';
import { WizardPage } from "../../../nexus-portals-wizard-react";
import {ViewModelForm} from "gw-portals-viewmodel-react";
import {TranslatorContext} from "@jutro/locale";
import {readViewModelValue} from "gw-jutro-adapters-react";
import BankPaymentMethodComponent from '../../../gw-capability-common-components/EFTComponent/BankPaymentMethodComponent';
import { fnolCommonMessages } from 'gw-capability-fnol-common-react';


function PaymentPreference(props) {

    const {
        wizardData: claimVM,
        updateWizardData
    } = props;

    const translator = useContext(TranslatorContext);

    const paymnetOptions = useMemo(() => {
        const filteredOptions = _.filter(claimVM.mainContact.paymentMethod.aspects.availableValues, (typeCode) => {
            return typeCode.code !== 'manual';
        }).map((typeCode) => {
            return {
                code: typeCode.code,
                name: translator({
                    id: typeCode.name,
                    defaultMessage: typeCode.name
                })
            };
        });
        return filteredOptions;
    }, [claimVM])

    const alertEFTPayment = (value) => {
        if (value === 'eft') {
            ModalNextProvider.showConfirm({
                title: messages.eftNoteTitle,
                message: messages.eftMessage,
                confirmButtonText: messages.btnLabelYes,
                cancelButtonText: messages.btnLabelNo,
                className: styles.modalBoxWidth
            }).then((option) => {
                if (option === 'confirm') {
                    _.set(claimVM, 'mainContact.paymentMethod.value', value);
                    _.set(claimVM, 'mainContact.eftdataDTO.value', {
                        isValidationRequired: true,
                        isPrimary: true
                    });
                    updateWizardData(claimVM);
                }
            }).catch(_.noop);
        } else {
            _.set(claimVM, 'mainContact.paymentMethod.value', value);
            _.set(claimVM, 'mainContact.eftdataDTO.value', null);
            updateWizardData(claimVM);
        }
    }

    const updateEFTRecord = async (eftData) => {
        _.set(claimVM, 'mainContact.eftdataDTO.value', eftData);
        updateWizardData(claimVM);
        if (!_.isEmpty(eftData)) {
            return 'validation';
        }
        return null;
    }

    const overrideProps = {
        paymentMethodOptions: {
            availableValues: paymnetOptions || [],
            value: _.get(claimVM, 'mainContact.paymentMethod.value.code')
        },
        eftPayment: {
            visible: _.get(claimVM, 'mainContact.paymentMethod.value.code') === 'eft',
            props: props,
            initialData: _.get(claimVM, 'mainContact.eftdataDTO.value'),
            selectedPaymentMethod: _.get(claimVM, 'mainContact.paymentMethod.value.code'), //claimVM.mainContact.eftdataDTO.aspects.subtreeValid ? _.get(claimVM, 'mainContact.paymentMethod.value.code') : 'check',
            showBankPaymentFields: _.get(claimVM, 'mainContact.paymentMethod.value.code') === 'eft',
            editEFTData: false,
            updateEFTData: (eftData) => {
                return updateEFTRecord(eftData);
            },
            cancelEFTDataUpdate: () => {
                _.set(claimVM, 'mainContact.paymentMethod.value', 'check');
                updateEFTRecord(null);
            }
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrideProps);
        },
        [claimVM, overrideProps]
    );

    const resolvers = useMemo(
        () => ({
            resolveValue: readValue,
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                alertEFTPayment
            },
            resolveComponentMap: {
                bankPaymentMethodComponent: BankPaymentMethodComponent
            }
        }),
        [readValue]
    );

    return (
        <WizardPage
            nextLabel={translator(fnolCommonMessages.reviewInformation)}
            disableNext={!(claimVM.aspects.subtreeValid && claimVM.aspects.valid)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                resolveValue={resolvers.resolveValue}
            />
        </WizardPage>
    );
}

export default PaymentPreference;
